module.exports = __webpack_public_path__ + "media/assets/images/blog/betafeaturewip-2d285b4669fc3857b281653e0d439d1f.png";